#import '../fragments/marketing-automation-fragment.graphql'

query GetMoneyPage($id: ID!) {
    maUrl(id: $id) {
        id
        name
        url {
            id
            fullyQualifiedUrl
        }
        creatorUser {
            id
        }
        createdTime
        automation {
            ...MarketingAutomationFragment
        }
        isEnabled
        views
        lastTriggeredTime
    }
}
